<ng-container *ngIf="error">
    <div class="technical-info">{{ error | translate }}</div>
</ng-container>
